import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { api } from "../api";
import { ProductCard } from "../components/ProductCard";

export default function Shop() {
  const { category } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("default");
  const search = searchParams.get("search") || "";

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    if (search) params.search = search;
    api.get("/products", { params })
      .then((r) => {
        let data = r.data;
        if (sortBy === "price_asc") data = [...data].sort((a, b) => a.price - b.price);
        if (sortBy === "price_desc") data = [...data].sort((a, b) => b.price - a.price);
        setProducts(data);
      })
      .finally(() => setLoading(false));
  }, [category, search, sortBy]);

  const title = category ? category.charAt(0).toUpperCase() + category.slice(1) : "The Edit";

  return (
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 pt-32 pb-24" data-testid="shop-page">
      <div className="flex items-end justify-between border-b border-white/10 pb-10 mb-12">
        <div>
          <div className="overline text-muted-foreground">Collection</div>
          <h1 className="serif text-5xl md:text-6xl mt-3">{title}</h1>
          <div className="text-sm text-muted-foreground mt-3">{products.length} pieces</div>
        </div>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-4 text-xs uppercase tracking-[0.22em]">
            <Link to="/shop" className={!category ? "text-foreground" : "text-muted-foreground hover:text-foreground"}>All</Link>
            <Link to="/shop/women" className={category === "women" ? "text-foreground" : "text-muted-foreground hover:text-foreground"}>Women</Link>
            <Link to="/shop/men" className={category === "men" ? "text-foreground" : "text-muted-foreground hover:text-foreground"}>Men</Link>
            <Link to="/shop/accessories" className={category === "accessories" ? "text-foreground" : "text-muted-foreground hover:text-foreground"}>Accessories</Link>
          </div>
          <select
            className="bg-transparent border border-white/20 py-2 px-3 text-xs uppercase tracking-[0.18em] focus:border-white outline-none"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            data-testid="sort-select"
          >
            <option value="default" className="bg-background">Sort</option>
            <option value="price_asc" className="bg-background">Price Low → High</option>
            <option value="price_desc" className="bg-background">Price High → Low</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="text-muted-foreground text-sm">Loading…</div>
      ) : products.length === 0 ? (
        <div className="text-muted-foreground text-sm py-24 text-center">No pieces found in this selection.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-10">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
